/**
* Created by kongwm.kong on 2017/7/20.
*/
<template>
    <div class="register_page_wrap">
        <div class="layout_n">
            <div class="title">注册账户</div>
            <div class="register_validate">
                <form @submit.prevent="register">
                    <div class="filed">
                        <div class="input_wrap">
                            <!--<input type="text" name="company_name" v-model="company_name" v-validate="'required'" placeholder="公司全称">-->
                            <vue-instant :isAll="true" :suggestion-attribute="suggestionAttribute" @blur="validComVla"
                                         @input="changed" :show-autocomplete="true" v-model="value" :disabled="false"
                                         name="company_name" @selected="selected" placeholder="公司全称" type="google"
                                         :autofocus="false" :suggestions="suggestions"></vue-instant>
                            <span class="err">{{msgCom}}</span>
                            <div class="register_tips">
                                ps: 请勿输入公司完整全称，仅输入关键字后从下拉列表选取对应公司即可
                            </div>
                        </div>
                    </div>
                    <div class="filed">
                        <div class="input_wrap">
                            <input type="text" name="vipName" v-model="vipName" v-validate="'required|asyncVipName'"
                                   placeholder="设置用户名">
                            <span class="err" v-show="errors.has('vipName')">{{errors.first('vipName')}}</span>
                            <!--<span class="err" v-show="msg.asyncVipNameMsgFlag">{{msg.asyncVipNameMsg}}</span>-->
                        </div>
                    </div>
                    <div class="filed" @mouseenter="showTip=true" @mouseleave="showTip=false">
                        <div class="input_wrap">
                            <input type="password" name="password" v-model="password" v-validate="'required|password'"
                                   @blur="isEqual" placeholder="请输入密码">
                            <span class="err" v-show="errors.has('password')">{{errors.first('password')}}</span>
                        </div>
                        <div class="passTip-show">
                            <pass-tip :showFlag="showTip"></pass-tip>
                        </div>
                    </div>
                    <div class="filed">
                        <div class="input_wrap">
                            <input type="password" name="password1" v-model="password1" v-validate="'required'"
                                   @blur="isEqual" placeholder="请再次输入您的密码">
                            <span class="err" v-show="!errors.has('password1')">{{equalMsg}}</span>
                            <span class="err" v-show="errors.has('password1')">{{errors.first('password1')}}</span>
                        </div>
                    </div>
                    <div class="filed">
                        <div class="phonediv">+ 86</div>
                        <div class="input_wrap phoneform">
                            <input type="text" name="mobile" v-model="mobile" v-validate="'required|mobile|asyncMobile'"
                                   placeholder="请输入手机号码">
                            <span class="err" v-show="errors.has('mobile')">{{errors.first('mobile')}}</span>
                            <!--<span class="err" v-show="!errors.has('mobile')&&msg.asyncMobileFlag">{{msg.asyncMobileMsg}}</span>-->
                        </div>
                    </div>
                    <div class="filed">
                        <div class="input_wrap valid_form">
                            <input type="text" name="validImg" v-model="validImg" v-validate="'required'"
                                   placeholder="请输入验证码">
                            <span class="err" v-show="errors.has('validImg')">{{errors.first('validImg')}}</span>

                        </div>
                        <div class='img_valid_wrap'>
                            <div class="img_valid" @click="getImgCode"><img :src="imgSrc" width="110" height="40"></div>
                        </div>
                    </div>
                    <div class="filed">
                        <div class="input_wrap valid_form">
                            <input type="text" name="validCode" v-model="validCode" v-validate="'required|number'"
                                   placeholder="请输入手机验证码">
                            <span class="err" v-show="errors.has('validCode') && !msg.validCodeFlag">{{errors.first('validCode')}}</span>
                            <!--发送验证码后，出错提示-->
                            <span class="err" v-show="msg.validCodeFlag">{{msg.validCodeMsg}}</span>
                        </div>
                        <!--<div class='img_valid_wrap'>-->
                        <!--<div class="img_valid"><send-code :phone="mobile" @changeErrTipFlag="changeErrTipFlag"    :imageCode="validImg" :validPhone="errors.has('mobile') && msg.asyncMobileMsg" ></send-code></div>-->
                        <!--</div>-->
                    </div>
                    <div class="green">
                        <div :class="['checkbox_wrap', {'active': showActive}]"
                             @click="showActive=!showActive;msg.showActiveFlag=true">
                            <!--<input type="checkbox"  name="greenBox" v-validate="'required'">-->
                        </div>
                        <div class="text">
                            阅读并同意
                            <router-link target="_blank" to="/agree">《金斧子服务协议》</router-link>
                        </div>
                        <div class="err">
                            <span v-show="!showActive && msg.showActiveFlag">请阅读并同意《金斧子服务协议》</span>
                        </div>
                    </div>
                    <div class="go-register">
                        <button class="btn-bg-def" type="submit">注册</button>
                    </div>
                    <div class="err">{{errMsg}}</div>
                </form>

                <div class='img_valid_wrap code_valid_wrap'>
                    <div class="img_valid">
                        <button :class="['send-code', {'disabled':disabled}]" id="sendCode" @click="sendCode">发送验证码
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  //    import sendCode from '../../components/common/sendCode'
  import {Validator} from 'vee-validate';
  import passTip from './passTip';
  import CountDown from  '../../assets/js/common/countdown';
  export default {
    name: 'register',
    // 注册组件
    components: {
      passTip,
//            vueInstant
    },
    data (){
      return {
        errMsg: '',
        disabled: false,
        value: '',
        password: '',
        password1: '',
        equalMsg: '',
        mobile: '',
        showTip: false,
        vipName: '',
        showActive: false,
        showFlag: true,
        msgCom: '',
        companyCode: '',
        suggestionAttribute: 'companyFullName',
        suggestions: [],
        imgSrc: '/v1/security-code/image',
        validImg: '',
        validCode: '',
        msg: {
          validCodeFlag: false,
          validCodeMsg: '',
          asyncMobileFlag: false,
          asyncMobileMsg: '手机号码已存在',
          asyncVipNameFlag: false,
          asyncVipNameMsg: '会员名已存在',
          showActiveFlag: false,
          value: null

        }
      }
    },
    computed: {
      huluanxie(){
        return false;
      },
      equalPass(){
        if (this.password === this.password1) {
          return '1';
        } else {
          return '0';
        }

      }

    },
    mounted(){
//            $('input[name="greenBox"]').prop('checked', false);
    },
    methods: {
      sendCode(e){
        e.preventDefault();
        this.authCode = new CountDown({
          id: 'sendCode',
          disabledClass: 'send-code disabled',
          normalClass: 'send-code ',
          clickFont: '秒后重新发送',
          afterFont: '发送验证码',
          path: '/',
          pathFlag: '11'
        });
        let imgCode = $("input[name='validImg']").val();
        if (!(this.errors.has('mobile')) && this.mobile && imgCode) {
          let url = `/security-code/${this.mobile}/sendPhoneSecurityCode?imageCode=${imgCode}`;
          this.$http.request({
            url: url
          }, response => {
            if (response.data.code === 401) {
              let obj = {
                flag: true,
                msg: response.data.message
              };
              this.changeErrTipFlag(obj);  //出错后的提示
              this.getImgCode();
            } else if (response.data.code == 200) {
              this.authCode.startCount();
              this.changeErrTipFlag({flag: false, msg: ''});
            } else {
              this.getImgCode();
            }
          }, err => {
            this.getImgCode();
          });
        } else {
          this.changeErrTipFlag({flag: true, msg: '请输入正确手机号码、验证码'});
        }

      },
        /*验证码出错后提示*/
      changeErrTipFlag(obj){
        this.msg.validCodeFlag = obj.flag;
        this.msg.validCodeMsg = obj.msg;
      },
      blurCode(){
//                setTimeout(()=>{
//                    this.validComVla();
        if (this.companyCode == null || this.companyCode == '') {
          return false;
        }
        this.$http.request({
          url: `/account/register/checkByCompany?company=${this.companyCode}`
        }, (response) => {
          if (response.data.code === 200) {
            this.showFlag = response.data.data;
            if (!this.showFlag) {
              this.msgCom = "抱歉,公司与账户已绑定";
            } else {
              this.msgCom = '';
            }
          } else {
            this.msgCom = "找不到该公司，请重新输入";
            this.showFlag = false;
          }
        }, (err) => {
          this.msgCom = "找不到该公司，请重新输入";
          this.showFlag = false;
        });
//                },1000);
      },
        /*验证会员名*/
      asyncVipName(e){
        let val = e.target.value;
        setTimeout(() => {
          this.$http.request({
            url: `/account/register/checkByUserName?userName=${val}`
          }, response => {
            if (response.data.code === 200) {
              this.msg.asyncVipNameFlag = response.data.data;
            } else {
              this.msg.asyncVipNameFlag = false;
            }
          }, err => {

          })
        }, 1000);
        if (val.length === 0) {
          this.msg.asyncVipNameFlag = false;
        }
      },
        /*验证手机号*/
      asyncMobile(e){
        let val = this.mobile;
        if (val.length === 11) {
          this.$http.request({
            url: `/account/register/checkByPhone?phone=${val}`
          }, response => {
            if (response.data.code === 200) {
              this.msg.asyncMobileFlag = response.data.data;
            } else {
              this.msg.asyncMobileFlag = false;
            }
          }, err => {

          })
        } else if (val.length === 0) {
          this.msg.asyncMobileFlag = false;
        }
      },

      validComVla(){
        if (!this.value || this.value == '') {
          this.msgCom = '请输入公司全称';
        } else if (this.companyCode == '' || this.companyCode == null) {
          this.msgCom = '请选择公司全称';
        }
      },
        /*模糊查询，选择*/
      selected(obj) {
        if (obj != null) {
          this.value = obj.companyFullName;
          this.companyCode = obj.fundDcId;
        }
      },
      isEqual(){
        if (this.password === this.password1) {
          this.equalMsg = ''
        } else if (this.password1.length && this.password.length) {
          this.equalMsg = '两次密码不一致，请重新输入'
        }
      },
      clearVal(event){
        let dom = $(event.target);
        let inputDom = dom.parents('.input_wrap').find('input');
        inputDom.val('');
      },
      showeye(event){
        let dom = $(event.target);
        let inputDom = dom.parents('.input_wrap').find('input');
        if (inputDom.attr('type') === 'text') {
          inputDom.attr('type', 'password')
        } else {
          inputDom.attr('type', 'text');
        }
      },
      changed(){
        this.suggestions = [];
        this.companyCode = null;

        if (this.value && this.msg.value != this.value && this.value.length > 1) {
          this.msg.value = this.value;
          let msgtext = encodeURIComponent(this.value);
          this.$http.request({
            url: `/company/list/sample?key=${msgtext}`
          }, response => {
            if (response.data.code === 200 && response.data.data) {
              this.suggestions = response.data.data;
            }
            this.msg.value = null;
          }, function (err) {
//                            console.log(err);
          });
        }
      },
      showCheck(e){
      },
      getImgCode(e){
        this.imgSrc = '/v1/security-code/image?' + Math.random();
        this.validImg = '';
      },
      register(){
        this.validComVla();
        if (!this.msg.showActiveFlag) {
          this.msg.showActiveFlag = true;
        }
        this.$validator.validateAll().then(result => {
          if (result && this.equalMsg === '' && this.msg.showActiveFlag && this.showActive && this.msgCom == '' && !this.msg.asyncVipNameFlag && !this.msg.asyncMobileFlag && this.companyCode) {
            this.$http.request({
              url: '/account/register',
              method: 'post',
              data: {
                'userName': this.vipName,
                'password': this.password,
                'companyCode': this.companyCode,
                'phoneSecurityCode': this.validCode
              }
            }, (response) => {
              if (response.data.code === 200) {
                this.errMsg = '';
                if (response.data.data) {
//                                    this.$router.go('/registerSuc');
                  this.$router.push({path: '/registerSuc'});
                } else {
                  this.errMsg = response.data.message;
                }
              } else if (response.data.code === 401) {
                this.errMsg = response.data.message;
              }
            }, (err) => {
              this.errMsg = '服务器繁忙';
            });
            return false;
          }

        });
      }
    },
    watch: {
      companyCode(){
        this.blurCode();
      }
//            value(){
//                if(this.value.length<2){
//                    this.msgCom = '请输入公司全称';
//                }else {
//                    this.msgCom ='';
//                }
//            }
    },
    created(){
//            this.getImgCode();
    }
  };
</script>
<style lang="scss" type="text/scss" scoped>
    .register_page_wrap {
        margin-top: 30px;
        margin-bottom: 50px;
        .layout_n {
            background: #fff;
            padding: 40px 40px 100px;
        }
        .register_tips{
            font-size: 14px;
            width: 500px;
            line-height: 24px;
            color: #999;
        }
        .send-code {
            position: absolute;
            right: 1px;
            top: 383px;
            width: 110px;
            height: 38px;
            background: $c_f5f;
            font-size: 14px;
            color: $btn_408;
            &.disabled {
                color: $c_989;
            }
        }
        .title {
            font-size: 18px;
            color: $c_3c3;
            letter-spacing: -0.43px;
            border-left: 6px solid $btn_408;
            text-indent: 7px;
            height: 20px;
            line-height: 1;
            margin-bottom: 40px;
        }
        .register_validate {
            width: 330px;
            margin: 0 auto;
            position: relative;
            .filed {
                color: $c_666;
                font-size: 16px;
                line-height: 1;
                height: 40px;
                position: relative;
                .passTip-show {
                    position: absolute;
                    top: -12px;
                    left: 103%;
                }
                &.filed:nth-child(2){
                    margin-top: 32px;
                }
                & + .filed {
                    margin-top: 22px;
                }
                .input_wrap {
                    height: 40px;
                }
                border: 1px solid $border_bfb;
                input {
                    width: 100%;
                    padding: 10px 0 10px 20px;
                    font-size: 16px;
                    line-height: 16px;
                    height: 38px;
                }
                .err {
                    position: absolute;
                    top: 10px;
                    left: 340px;
                    width: 300px;
                    color: $c_ff5;
                    text-align: left;
                }
                .phonediv {
                    display: inline-block;
                    width: 64px;
                    height: 100%;
                    font-size: 16px;
                    color: $c_b7b;
                    letter-spacing: -0.39px;
                    line-height: 40px;
                    text-align: center;
                    border-right: 1px solid $border_bfb;
                    margin-right: 0;
                }
                .phoneform {
                    /* display: inline-block;*/
                    float: right;
                    width: 259px;
                    input {

                    }
                }
                .img_valid_wrap {
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 110px;
                    height: 100%;
                    background: #f5f5f5;
                    color: $btn_408;
                    font-size: 14px;
                    line-height: 40px;
                    text-align: center;
                    img {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            .green {
                margin-top: 22px;
                font-size: 14px;
                .checkbox_wrap {
                    display: inline-block;
                    width: 16px;
                    height: 16px;
                    // border:1px solid $btn_408;
                    vertical-align: middle;
                    position: relative;
                    background: url(../../assets/img/common/check.png) no-repeat center center;
                    &.active {
                        background-image: url(../../assets/img/common/checked.png);
                    }
                    input {
                        opacity: 0;
                        position: absolute;
                    }
                }
                .text {
                    display: inline-block;
                    color: $c_b7b;
                    a {
                        color: $btn_408;
                    }
                }
            }
            .go-register {
                margin-top: 20px;
                height: 40px;
                background: $btn_408;
                text-align: center;
                font-size: 18px;
                color: #fff;
                font-weight: bold;
                line-height: 40px;
                cursor: pointer;
                position: relative;
                button {
                    position: absolute;
                    left: 0;
                    top: 0;
                    color: #fff;
                    width: 100%;
                    height: 100%;
                }
            }
        }

    }

    .common_footer_wrap {
        background: #f0f0f0;
    }
</style>


// WEBPACK FOOTER //
// src/views/user/register.vue